module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "food-result"
  }, [_c('mu-content-block', {
    staticClass: "blueHeader"
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('md-icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "default"
    },
    domProps: {
      "textContent": _vm._s('close')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('addFoodDialog')
      }
    },
    slot: "default"
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-paper', {
    staticStyle: {
      "position": "relative",
      "z-index": "99"
    }
  }, [_c('mu-list', {
    staticStyle: {
      "padding-top": "0",
      "padding-bottom": "0"
    }
  }, [_c('mu-list-item', {
    attrs: {
      "disableRipple": "",
      "describeText": _vm.food.brand_name
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.isLoading ? _vm.$t('message.loadingText') : _vm.food.food_name)
    }
  })]), _vm._v(" "), (_vm.mode === '') ? _c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('goBack', 's')
      }
    },
    slot: "left"
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "scrollable-area"
  }, [(!_vm.isLoading) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": _vm.leftPaneWidth.desktop,
      "tablet": _vm.leftPaneWidth.tablet
    }
  }, [_c('mu-content-block', {
    staticStyle: {
      "padding": "16px 24px"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": _vm.servingPickerWidth.servingInput.desktop,
      "tablet": _vm.servingPickerWidth.servingInput.tablet
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0|max_value:99'),
      expression: "'required|min_value:0|max_value:99'"
    }],
    attrs: {
      "data-vv-name": "serving_size",
      "data-vv-as": _vm.$t('message.labelServingSize'),
      "errorText": _vm.errors.first('serving_size'),
      "min": 0,
      "type": "number",
      "hintText": _vm.$t('message.labelMultiplier'),
      "label": _vm.$t('message.labelServingSize'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.servings),
      callback: function($$v) {
        _vm.$set(_vm.model, "servings", _vm._n($$v))
      },
      expression: "model.servings"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": _vm.servingPickerWidth.servingSelector.desktop,
      "tablet": _vm.servingPickerWidth.servingSelector.tablet
    }
  }, [_c('mu-select-field', {
    attrs: {
      "scroller": _vm.scroller,
      "maxHeight": 248,
      "label": " ",
      "fullWidth": "",
      "autoWidth": ""
    },
    model: {
      value: (_vm.model.serving_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "serving_id", _vm._n($$v))
      },
      expression: "model.serving_id"
    }
  }, _vm._l((_vm.food.servings), function(serving, index) {
    return _c('mu-menu-item', {
      key: 'serving-' + index,
      attrs: {
        "value": serving.serving_id,
        "title": serving.serving_description
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": _vm.servingPickerWidth.servingInput.desktop,
      "tablet": _vm.servingPickerWidth.servingInput.tablet
    }
  }, [_c('span', [_c('mu-flexbox', {
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    staticStyle: {
      "font-weight": "500"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.foodDiaryQuickPortionLabel'))
    }
  })], 1)], 1)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": _vm.servingPickerWidth.servingSelector.desktop,
      "tablet": _vm.servingPickerWidth.servingSelector.tablet
    }
  }, [_c('span', [_c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('0.25')
      }
    }
  }, [_vm._v("1/4")]), _vm._v(" "), _c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('0.5')
      }
    }
  }, [_vm._v("1/2")]), _vm._v(" "), _c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('0.75')
      }
    }
  }, [_vm._v("3/4")]), _vm._v(" "), _c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('1')
      }
    }
  }, [_vm._v("1")])], 1)])], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": _vm.servingPickerWidth.servingInput.desktop,
      "tablet": _vm.servingPickerWidth.servingInput.tablet
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "container": "inline",
      "label": _vm.$t('message.labelTime'),
      "mode": "landscape",
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    model: {
      value: (_vm.timeModel.time),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "time", $$v)
      },
      expression: "timeModel.time"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": _vm.servingPickerWidth.servingSelector.desktop,
      "tablet": _vm.servingPickerWidth.servingSelector.tablet
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "container": "inline",
      "label": _vm.$t('message.labelDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "fullWidth": ""
    },
    model: {
      value: (_vm.timeModel.date),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "date", $$v)
      },
      expression: "timeModel.date"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.isNutritionPaneVisible) ? _c('mu-col', {
    staticClass: "rightPane",
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-card-header', {
    staticClass: "removePadding",
    attrs: {
      "subTitle": _vm.model.servings + ' x ' + _vm.activeServingObject.serving_description
    }
  }), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-list', {
    staticClass: "oddEven"
  }, _vm._l((_vm.activeServingObject.nutrients), function(value, key) {
    return _c('mu-list-item', {
      key: 'nutrient-' + key,
      attrs: {
        "disableRipple": "",
        "title": _vm.$t(_vm.localizeNutrient(key)),
        "afterText": '' + _vm.rounded(value * _vm.model.servings) + _vm.getUnit(key)
      }
    })
  }), 1)], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.isLoading) ? _c('mu-card-actions', {
    staticClass: "card-actions",
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.cancelText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('addFoodDialog')
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText'),
      "disabled": _vm.isSaving,
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveFood()
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dfa8859a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FoodDiary/FoodResultDialog/FoodResultDialog.vue
// module id = 3853
// module chunks = 1